import { getCapability } from '@app-iptv/device'
import type { Tier } from '@app-iptv/shared'

import type { MediaPlayer } from './types'
import { WebPlayer, preloadMpegts, mpegtsOptionsFor, type WebPlayerOptions } from './WebPlayer'

export * from './types'
export { WebPlayer, preloadMpegts, mpegtsOptionsFor }
export type { WebPlayerOptions }
// `redactStreamUrl` mora em `@app-iptv/shared` (util compartilhado de redação de
// credencial) — importe de lá, não daqui.

// Factory simples por enquanto — Fase 4 adiciona TizenAVPlayer/WebOSPlayer; Fase 5 AndroidPlayer
export function createPlayer(tier: Tier = 'mid', opts?: WebPlayerOptions): MediaPlayer {
  // `nativeTs` default vem da CAPABILITY do device (classe provada webOS gen 4-5,
  // `canPlayNativeTs`). Caller pode forçar (testes/casos especiais). Ligar a
  // capability é INERTE em players de VOD/série/catchup: o ramo native-ts só
  // dispara pra `source.type === 'mpegts'` (live). Em web/mobile/TV-não-alvo a
  // capability é false → LIVE segue byte-idêntico no mpegts.js (não-regressão).
  const nativeTs = opts?.nativeTs ?? getCapability('nativeTsPlayback')
  return new WebPlayer(tier, { nativeTs })
}
